import { SVGProps, Ref, forwardRef } from 'react';

export const CheckCircleFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .5C2.375.5.5 4.25.5 8s1.875 7.5 7.5 7.5 7.5-3.75 7.5-7.5S13.625.5 8 .5M11.987 6l-.99-.99-3.999 3.999-2-2-.99.99 2.99 2.99z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
CheckCircleFilledSize16Glyph.displayName = 'CheckCircleFilledSize16Glyph';
